import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer'; 
const RegistrationForm = () => {
    useEffect(() => {
        document.title = 'Registration Form -  Sacred Heart School, Ballia - U.P.';  
    }, []); 
   return (
        <>
        <Header/>
            <section className="page-header"> 
                    <div className="page-header__inner">
                    <h2>Registration Form </h2>
                        <ul className="thm-breadcrumb list-unstyled ml-0">
                            <li><Link to="/"> Home</Link></li>
                            <li>|</li>
                            <li>Admission</li>
                            <li>|</li>
                            <li> Registration Form </li>
                        </ul> 
                </div>
            </section>
            <section className="innerbody">
               <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                       <h1 className="head1" >General Rules</h1>
                       <ul className="list schoolfee">
                                <li>For Playgroup – At least 2.5 years and maximum 3.5 years as on 31st March of the current year.</li>
                                <li>For LKG – At least 3.5 years and maximum 4 years as on 31st March of the current year.</li>
                                <li>For UKG – At least 4 years and maximum 5 years as on 31st March of the current year.</li>
                                <li>An Incomplete form will be rejected.</li>
                                <li>Please attach a copy of Original Birth Certificate at the time of Submission of the form.</li>
                                <li>If the FEES are NOT PAID in time, or if any procedures are left incomplete, you will FORFEIT YOUR ADMISSION.</li>
                                <li>Parents are expected to accompany their son/daughter for the interview.</li>
                                <li>All admissions are based on the policies of the Management. The decision of the Principal is final and binding.</li>
                                <li>Kindly refrain from bringing recommendations or constantly requesting admission for those already refused.</li>
                                <li>Parents of school students must be available whenever the School needs them.</li>
                    </ul>
                     </div>
                </div>
               </div>
             </section>
            <Footer/>
        </>
    )
}

export default RegistrationForm